export default {
  SET_QUOTE_EXTERNAL_LINK (state, quoteExternalLink) {
    state.quoteExternalLink = quoteExternalLink
  }
}



// WEBPACK FOOTER //
// ./src/modules/library/store/mutations.js